import { call, put, takeEvery } from "redux-saga/effects";
import * as actions from "./agentsBuildsGetActions";
import platformList from "data/downloads";
import { api, getAuthHeaders, createApiHooks } from "tools/apiConfigurator";
import { getCurrentSession } from "tools/localStorage";
import { hasFeatureFlag, ffKeys } from "@p81-common/shell-core-js";

const ARM64_PACKAGE_TYPES = ['exeArm64', 'msiArm64'];

function* agentsBuildsGet(action) {
  try {
    const session = getCurrentSession();
    const { data: platforms } = yield api
        .get("agent-builds", {
          headers: getAuthHeaders(),
          hooks: session ? createApiHooks(true) : undefined,
        })
        .json();

    let result = platformList
      .map((platform) => {
        let { name, packageType } = platform;
        if (platforms[name]?.[packageType]) {
          return { ...platform, ...platforms[name][packageType] };
        }
        return platform;
      })
      .filter((platform) => {
        if (ARM64_PACKAGE_TYPES.includes(platform.packageType)) {
          return !!platform.agentCdnUrl;
        }
        if (platform.packageType === "With Mobile Protect") {
          return hasFeatureFlag(ffKeys.DOWNLOAD_PAGE_MERGED_APPLICATION);
        }
        return true;
      });

    yield put(actions.requestSuccess(result));

    if (action.resolve) {
      yield call(action.resolve, result);
    }
  } catch (error) {
    yield put(actions.requestFailure(error));

    if (action.reject) {
      yield call(action.reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.AGENTS_BUILDS_GET_REQUEST, agentsBuildsGet);
}

export default saga;
